export function closeWindow() {
  window.close()
}
